import AuthService from "@/services/AuthService";
import swal from "sweetalert";
export default {
  created: function() {
    this.displayMessage();
  },
  onIdle() {
    this.$store.dispatch("logout");
    this.$router.push({
      name: "Login"
    });
    swal({
      text: this.$t("string698"),
      icon: "error",
      button: {
        text: this.$t("Close"),
        className: "swal-close"
      }
    });
  },
  methods: {
    displayMessage: function() {
      if (this.$store.getters.isLoggedIn) {
        var token = this.$store.state.token;
        AuthService.profile({
          headers: { Authorization: "Bearer " + token }
        })
          .then({})
          .catch(err => {
            if (err) {
              swal({
                text: this.$t("string698"),
                icon: "error",
                button: {
                  text: this.$t("Close"),
                  className: "swal-close"
                }
              });
              this.$store.dispatch("logout");
              this.$router.push({
                name: "Login"
              });
            }
          });
      }
    }
  }
};
